import React from 'react';
import {useModel} from '../../index.jsx';

import BCMSDisabledPrompt from '../BCMSDisabledPrompt/main.jsx';
import BCMSTemplate from '../../classes/BCMSTemplate/index.js';

// Defines BRANDING element for BCMS componets:
export default function BCMSBranding(props) {
  let {id, value, exp, model, type} = props;
  let setBrandingValue = model[id];
  let pred = exp === undefined
    ? setBrandingValue === value
    : exp(setBrandingValue)
  return pred === true
    ? (<>{props.children}</>)
    : null
}

// Defines component for applying expression to branding:
// :: {props.exp = ({options, colors}) -> BOOLEAN}
export function BCMSBrandingExp(props) {
  let {exp, model} = props;
  let {options, colors} = model;
  if (typeof(exp) === "function") {
    return pred === exp({options, colors})
      ? (<>{props.children}</>)
      : null
  } {
    throw new Error(`Branding Expression "${exp}" must be a function!`);
  }
}

// Defines component for creating image tag using branding from model:
// :: {props.id:BRANDING_VARIABLE, props.className:CSS_CLASS_NAME, props.alt:IMG_ALT} -> React.Component
export function BCMSBrandingImage(props) {
  let {branding} = useModel();
  let val = branding.colors[props.id];
  return(<img src={val} className={props.className} alt={props.alt} />)
}

// Defines component for declaring inline style of first element using values from branding:
// :: {props.style:{rule:BRANDING_VARIABLE}, props.className:CSS_CLASS_NAME, props.element:React.Component} -> React.Component
// NOTE: "Element" property binds styling to given element, others a div is created and applies branding to all children of BCMSBrandingStyles
export function BCMSBrandingStyle({style, className, children, element}) {
  let {branding} = useModel();
  let {colors} = branding;

  const error = value => console.log(`ERROR: Could not find Color with a value of "${ value }"`);

  let brandedStyles = Object.entries(style ?? {}).reduce((result, [rule, id]) => {
    const template = BCMSTemplate.init(colors);
    const hasMatched = template.getMatchedValues(id).length > 0;

    if(hasMatched) { result[rule] = template.applyTo(id, error); }
    else {
      if(colors[id] === undefined) { error(id); }
      result[rule] = colors[id];
    }

    return result;
  }, {});

  return element !== undefined 
    ? React.cloneElement(element, {style:brandedStyles, className})
    : <div style={ brandedStyles } className={className}>{children}</div>;
}

// BCMSBrandingDisabledIf :: {props.id:BRANDING_VARIABLE, props.value: BRANDING_VALUE, props.exp: BRANDING_EXPRESSION} -> React.Component
// Defines the component for branding, if the value or expression return true then the child is returned
// otherwise return the element wrapped in a disabled prompt
export function BCMSBrandingDisabledIf(props) {
  const { id, value, exp } = props;
  const { branding } = useModel();
  const { options } = branding;
  
  const setBrandingValue = options[id];
  const pred = exp === undefined
    ? setBrandingValue === value
    : exp(setBrandingValue);

  return pred === true
    ? props.children 
    : <BCMSDisabledPrompt>{ props.children }</BCMSDisabledPrompt>;
}